<script lang="ts">
  import { navigate } from "../../app.logic";
  import CommentListEditor from "../../components/Business/CommentListEditor.svelte";
  import OwnershipListEditor from "../../components/Business/OwnershipListEditor.svelte";
  import PortalUserDropdown from "../../components/Business/PortalUserDropdown.svelte";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  // import UserTimeStats from "../../components/Business/UserTimeStats.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import type { ICompany, ICompanyData } from "../../entities";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import { PermissionService } from "../../utils/misc/permission-utils";
    import { user } from "../../app.store";

  import {
    companyInvoicesSemaphore,
    record,
    recordData,
    save,
    saveData,
    comments,
    activities,
    ownerships,
    addComment,
    delComment,
    addActivity,
    completeActivity,
    addOwner,
    delOwner,
    customFieldsSchemas,
  } from "./company.store";
import Switch from "../../components/Form/Fields/Switch.svelte";
import MagazineSideEditor from "../../components/Business/MagazineSideEditor.svelte";
import Secur8SideEditor from "../../components/Business/Secur8SideEditor.svelte";
import { showToast } from "../../utils/misc/toast-utils";
import ActivityListEditor from "../../components/Business/ActivityListEditor.svelte";
import type { IActivityDTO, ICompanyDTO } from "../../services/DTO";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && $record.name != "";

  let issupplier = window.location.pathname.indexOf("supplier") >= 0;

  let cancreate: boolean = PermissionService.isAllowedTo($user, 'companies.cancreate');
  let canedit : boolean = PermissionService.isAllowedTo($user, 'companies.canedit'); 

  async function onSaveMagazine(ev: any)
  {
    $recordData.clfMagazineId = ev.detail;
    let _resp: IApiResponse<ICompanyData> = await saveData();
    let u = _resp.payload;
    recordData.set(u);
    showToast("Operazione completata", 'is-success' );
  }

  async function onSaveSecur8(ev: any)
  {
    $recordData.clfSecur8Id = ev.detail;
    let _resp: IApiResponse<ICompanyData> = await saveData();
    let u = _resp.payload;
    recordData.set(u);
    showToast("Operazione completata", 'is-success' );
  }

  async function onEditActivity(event)
  {

  }

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<ICompany> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/company/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/company`);
  }

  // onMount(() => initDetail(oid));
</script>

{#if $record && $recordData}
  <div class="columns">
    <div class="column is-9">
      <FormLayout submitEnabled={cancreate && isNew || canedit && !isNew} {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
      {#if !issupplier}
        <div class="columns">
          <div class="column is-12">
              {#if $record.blocco == 'B'}
                <span class="tag is-danger is-large" >BLOCCO AMMINISTRATIVO</span>
              {/if}
              {#if $record.blocco == 'I'}
                <span class="tag is-danger is-large" >BLOCCO AMMINISTRATIVO</span>
              {/if}
              {#if !($record.cribStato == '' || $record.cribStato == ' ' || $record.cribStato == 'Attiva')}
                <span class="tag is-danger is-large" >CRIB: {$record.cribStato}</span>
              {/if}

              {#if $companyInvoicesSemaphore == 'warning'}
                <span class="tag is-warning is-large" >FATTURE NON PAGATE &lt;3m</span>
              {/if}
              {#if $companyInvoicesSemaphore == 'danger'}
                <span class="tag is-danger is-large" >FATTURE NON PAGATE &gt;3m</span>
              {/if}
          </div>
        </div>
      {/if}
        <div class="columns">
          <div class="column is-8">
            <FormField>
                <Input
                name="Ragione Sociale"
                placeholder="Ragione Sociale"
                required={true}
                bind:value={$record.name}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>

          <div class="column is-4">
            <FormField>
              <Input
                name="Tipologia"
                placeholder="Tipologia"
                maxlength={1}
                bind:value={$record.companyType}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
            <FormField>
              <Input
                name="Indirizzo"
                placeholder="Indirizzo"
                required={false}
                bind:value={$record.address}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>

          <div class="column is-2">
            <FormField>
              <Input
                name="CAP"
                placeholder="CAP"
                required={false}
                maxlength={5}
                bind:value={$record.zipCode}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>

          <div class="column is-2">
            <FormField>
              <Input
                name="Comune"
                placeholder="Comune"
                required={false}
                maxlength={50}
                bind:value={$record.city}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>

          <div class="column is-2">
            <FormField>
              <Input
                name="Provincia"
                placeholder="Provincia"
                required={false}
                maxlength={2}
                bind:value={$record.province}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>

          <div class="column is-2">
            <FormField>
              <Input
                name="Nazione"
                placeholder="Nazione"
                required={false}
                maxlength={50}
                bind:value={$record.country}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input
                name="Codice Fiscale"
                placeholder="Codice Fiscale"
                required={false}
                maxlength={16}
                bind:value={$record.fiscalCode}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Input
                name="Partita IVA"
                placeholder="Partita IVA"
                required={false}
                maxlength={11}
                bind:value={$record.vatNumber}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input
                name="PEC"
                placeholder="PEC"
                required={false}
                maxlength={100}
                bind:value={$record.pec}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Input
                name="Codice SDI"
                placeholder="Codice SDI"
                required={false}
                maxlength={50}
                bind:value={$record.sdi}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
            <FormField>
              <Input
                name="Prefisso IBAN"
                placeholder="Prefisso IBAN"
                required={false}
                maxlength={4}
                bind:value={$record.ibanPrefix}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-8">
            <FormField>
              <Input
                name="IBAN"
                placeholder="IBAN"
                required={false}
                maxlength={70}
                bind:value={$record.iban}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-2">
            <FormField>
              <NumberInput
                name="ABI"
                placeholder="ABI"
                required={false}
                maxlength={5}
                bind:value={$record.abi}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-2">
            <FormField>
              <NumberInput
                name="CAB"
                placeholder="CAB"
                required={false}
                maxlength={5}
                bind:value={$record.cab}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-1">
            <FormField>
              <Input
                name="CIN"
                placeholder="CIN"
                required={false}
                maxlength={1}
                bind:value={$record.cin}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <NumberInput
                name="Conto"
                placeholder="Conto"
                required={false}
                bind:value={$record.accountNumber}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>

          <div class="column is-4">
            <FormField>
              <Input
                name="Conto Corrente"
                placeholder="Conto Corrente"
                required={false}
                maxlength={70}
                bind:value={$record.savingAccount}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input
                name="Tipo"
                placeholder="Tipo"
                required={false}
                maxlength={1}
                bind:value={$record.companyType}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <NumberInput
                name="Codice Pagamento"
                placeholder="Codice Pagamento"
                required={false}
                bind:value={$record.paymentCode}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input
                name="CRIBIS Codice Ateco"
                placeholder=""
                required={false}
                readonly={true}
                bind:value={$record.cribAteco}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Input
                name="CRIBIS Descrizione Ateco"
                placeholder=""
                required={false}
                readonly={true}
                bind:value={$record.cribDescrizioneAteco}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <Input
                name="CRIBIS Stato"
                placeholder=""
                required={false}
                readonly={true}
                bind:value={$record.cribStato}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <Input
                name="CRIBIS Numero Dipendenti"
                placeholder=""
                required={false}
                readonly={true}
                disabled={!(cancreate && isNew || canedit)}
                value={$record.cribNumDipendenti != null
                  ? "" + $record.cribNumDipendenti
                  : ""}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-3">
            <FormField>
              <Input
                name="CRIBIS Data Costituzione"
                placeholder=""
                required={false}
                readonly={true}
                disabled={!(cancreate && isNew || canedit)}
                value={$record.cribConstitutionDate != null
                  ? formatTimestampHuman($record.cribConstitutionDate)
                  : ""}
              />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input
                name="CRIBIS Data Inizio"
                placeholder=""
                required={false}
                readonly={true}
                disabled={!(cancreate && isNew || canedit)}
                value={$record.cribDataInizio != null
                  ? formatTimestampHuman($record.cribDataInizio)
                  : ""}
              />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input
                name="CRIBIS Data Cessazione"
                placeholder=""
                required={false}
                readonly={true}
                disabled={!(cancreate && isNew || canedit)}
                value={$record.cribDataCessazione != null
                  ? formatTimestampHuman($record.cribDataCessazione)
                  : ""}
              />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              <Input
                name="CRIBIS Data Aggiornamento"
                placeholder=""
                required={false}
                readonly={true}
                disabled={!(cancreate && isNew || canedit)}
                value={$record.cribAggiornamento != null
                  ? formatTimestampHuman($record.cribAggiornamento)
                  : ""}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <FormField>
              <NumberInput
                name="Codice Anomalia"
                placeholder=""
                required={false}
                bind:value={$record.codAnomalia}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
          <div class="column is-6">
            <FormField>
              <NumberInput
                name="Codice Sospensione"
                placeholder=""
                required={false}
                bind:value={$record.codSospensione}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

         

        <div class="columns">
          <div class="column">
            <FormField>
              <PortalUserDropdown
                name="Responsabile"
                required={false}
                clearVisible={true}
                bind:value={$record.responsibleUserId}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <FormField>
              <Textarea
                name="Note"
                placeholder="note"
                required={false}
                bind:value={$record.notes}
                disabled={!(cancreate && isNew || canedit)}
              />
            </FormField>
          </div>
        </div>

        <CustomFields
          schemas={$customFieldsSchemas}
          bind:values={$record.customFields}
        />

        <!--
        <div class="columns">
          <div class="column">
            <kbd style="word-break:break-all;">
              {!!$record ? JSON.stringify($record) : ""}
            </kbd>
          </div>
        </div>
      -->
      </FormLayout>
    </div>
    <div class="column is-3">
      <!--
      <div class="box">
        <h1 class="subtitle">Riepilogo</h1>

      </div>
      -->
      <ActivityListEditor
        entityId={$record.oid}
        entityType={'Company'}
        activities={$activities}
        disabled={isNew}        
        on:save={addActivity} 
        on:edit={onEditActivity}
        on:complete={completeActivity}
      />          
      <MagazineSideEditor
        magId={$recordData.clfMagazineId}
        disabled={isNew}
        on:save={(ev) => onSaveMagazine(ev)}
      />
      <Secur8SideEditor
        clfSecur8Id={$recordData.clfSecur8Id}
        disabled={isNew}
        on:save={(ev) => onSaveSecur8(ev)}
      />
      <OwnershipListEditor
        entityId={$record.oid}
        ownerships={$ownerships}
        disabled={!(cancreate && isNew || canedit)}
        on:save={addOwner}
        on:delete={delOwner}
      />
      



    </div>
  </div>
{/if}
